import seed from './partners.json';

export const AUSTIN_REMODEL_PRO_ID = seed[0].id;
export const PARTNERS_SEED = seed;
